import React from "react";
import { Tooltip } from "antd";
import { CheckCircleFilled } from "@ant-design/icons";
import { settlementOf, statementLine } from "./riderLogic";
import { Money, NumberCell, money, toAdminTone } from "./settlementParts";

export default function SalarySheetRow({ rider, entry, onChange, saving, onSubmit }) {
  const s = settlementOf(rider, entry);
  const submitted = Boolean(rider.statement);
  const name = rider.name || `Rider #${rider.id}`;
  return (
    <tr className={submitted ? "stl-row--done" : undefined}>
      <td className="stl-sticky-start">
        <div className="stl-rider">
          <span className="stl-rider__name">{rider.name || "—"}</span>
          <span className="stl-rider__id">#{rider.id}</span>
        </div>
        {submitted && (
          <Tooltip title={statementLine(rider.statement)}>
            <span className="stl-pill stl-pill--done">
              <CheckCircleFilled /> Submitted
            </span>
          </Tooltip>
        )}
      </td>
      <td className="stl-strong">{rider.orders || 0}</td>
      <td className="stl-divide">
        <Money value={s.deliveryCharges} />
      </td>
      <td>
        <Money value={s.tips} />
      </td>
      <td>
        <Money value={s.surge} />
      </td>
      <td className="stl-divide">
        <NumberCell value={entry.incentive} label={`${name} incentive`} onChange={(v) => onChange("incentive", v)} />
      </td>
      <td>
        <NumberCell value={entry.special} label={`${name} special incentive`} onChange={(v) => onChange("special", v)} />
      </td>
      <td>
        <NumberCell value={entry.correction} label={`${name} correction`} onChange={(v) => onChange("correction", v)} />
      </td>
      <td className="stl-left">
        <input
          className="stl-input stl-input--sm stl-note-input"
          placeholder="Note for the rider"
          aria-label={`${name} note`}
          value={entry.notes}
          onChange={(e) => onChange("notes", e.target.value)}
        />
      </td>
      <td className="stl-divide">
        <Money value={s.cash} />
      </td>
      <td className={toAdminTone(s.toAdmin)}>{money(s.toAdmin)}</td>
      <td className="stl-divide">
        <Money value={s.cashInHand} />
      </td>
      <td>
        <Money value={s.chargesOwed} />
      </td>
      <td className="stl-sticky-end">
        <div className="stl-actions">
          <span className="stl-salary">{money(s.salary)}</span>
          <button
            type="button"
            className={`stl-btn stl-btn--sm stl-submit ${submitted ? "stl-btn--secondary" : "stl-btn--primary"}`}
            disabled={saving}
            onClick={onSubmit}
          >
            {saving ? "Saving…" : submitted ? "Resubmit" : "Submit salary"}
          </button>
        </div>
      </td>
    </tr>
  );
}
